import { IFsFileData, IFsFileType } from "@/components/r3f-components/component-data-structure"
import { filestore, Filestore } from "../store";
import { FsFile } from ".";

export class FsBaseFile implements IFsFileData {
    fs: Filestore
    id: string
    type: IFsFileType = IFsFileType.Unknown
    baseUrl: string
    size: number = 0
    name: string = ''

    constructor(fileId: string, name: string) {
        this.fs = filestore
        this.id = fileId
        this.name = name
        if (window.location.pathname.endsWith('/')) {
            this.baseUrl = `https://${window.location.host}${window.location.pathname}fs/${fileId}`
        } else {
            this.baseUrl = `https://${window.location.host}${window.location.pathname}/fs/${fileId}`
        }
    }

    load(): Promise<FsFile> {
        throw new Error("Method not implemented.");
    }
}
